import { ServiceAppService } from './../../../../security/service-app.service';
import { FileUpload } from './../../../../shared/fileupload/fileupload';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-cadastrar-fabrica-lista',
  templateUrl: './cadastrar-fabrica-lista.component.html',
  styleUrls: ['./cadastrar-fabrica-lista.component.scss']
})

export class CadastrarFabricaListaComponent implements OnInit {

  cols: any[];
  Marca: any;
  ValorAntigo: any;
  displayBasic2: boolean = false;
  Fabrica: any;
  colsMarca: any[];
  colsCruzamento: any[];
  descricaoDialog: string;
  first: number = 0;
  rows: number = 10;
  paginaAtual = 1;
  edit = false;
  dados: any[];
  dadosMarca: any[];
  dadosDropdown: any[];
  dadosCruzamento: any[];
  _selectedColumns: any[];
  dado: any = {};
  dadoMarca: any = {};
  dadoCruzamento: any = {};
  loading: boolean;
  dadosDialog: boolean;
  habilitar: boolean;
  editDialogMarca: boolean = false;
  editCruzamento: boolean = false;
  submitted: boolean;
  nomeFabrica = [];
  tamanhoPagina: any = 5;
  totalRegistros: any = 0;
  
  // Parâmetros Fábrica 
  parametrosFabrica: any = {
    processarArquivos: false, 
    envioAgregado: false,
    necessitaModelo: false,
    obrigatoriedadeTipoItem: false
  };
  
  // Controle do aviso de reinicialização
  mostrarAvisoReinicializacao: boolean = false;
  valorOriginalProcessarArquivos: boolean = false;
  
  // Controle do aviso de alterações não salvas
  mostrarAvisoAlteracoesNaoSalvas: boolean = false;
  parametrosOriginais: any = {
    processarArquivos: false,
    envioAgregado: false,
    necessitaModelo: false,
    obrigatoriedadeTipoItem: false
  };

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;

  constructor(private messageService: MessageService,
    private service: ServiceAppService,
    private config: PrimeNGConfig) { }

  ngOnInit(): void {
    this.retornaDados();
    this.pesquisar();
    this.pesquisarCruzamento();
    this.carregarParametros();

    this.cols = [
      { field: 'nome', header: 'Descrição' },
      { field: 'link', header: 'URL' },
      { field: 'portaBackEnd', header: 'Porta Back-End' },
      { field: 'portaFrontEnd', header: 'Porta Front-End' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.colsMarca = [
      { field: 'idMarca', header: 'Código Marca' },
      { field: 'descricao', header: 'Marca' },
      { field: 'usuarioCriacao', header: 'Responsável pela criação' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.colsCruzamento = [
      { field: 'nomeFabrica', header: 'Nome Fabrica', width: '500px' },
      { field: 'nomeMarca', header: 'Nome Marca', width: '500px' },
      { field: 'edit', header: 'Ações', width: '65px' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados('/cadastrar_fabrica').subscribe(res => {
      this.dados = res.dados;
      this.Fabrica = this.dados[0].id;
      this.nomeFabrica = [];

      this.dados.forEach(usuario => {
        this.nomeFabrica.push({ label: usuario.nome, value: usuario.nome });
      });
      this.loading = false;
    });

  }

  saveDados() {
    this.submitted = true;

    // Verifica se campo(s) estão preenchidos
    if (typeof this.dado.nome === "undefined") {
      this.messageService.add({ key: 'nome', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }
    if (typeof this.dado.link === "undefined") {
      this.messageService.add({ key: 'link', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }
    if (typeof this.dado.portaBackEnd === "undefined") {
      this.messageService.add({ key: 'portaBack', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }
    if (typeof this.dado.portaFrontEnd === "undefined") {
      this.messageService.add({ key: 'portaFront', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }

    // Verifica se for inserção ou alteracão
    if (this.edit) {
      this.service.putDados('/cadastrar_fabrica', {
        "id": this.dado.id,
        "nome": this.dado.nome,
        "link": this.dado.link,
        "portaBackEnd": this.dado.portaBackEnd,
        "portaFrontEnd": this.dado.portaFrontEnd
      }).subscribe(res => {
        this.retornaDados();
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dado Alterado com sucesso.', life: 3000 });
      });
      this.edit = false;
      this.dadosDialog = false;

    } else {
      this.service.postDados('/cadastrar_fabrica/default', {
        "nome": this.dado.nome,
        "link": this.dado.link,
        "portaBackEnd": this.dado.portaBackEnd,
        "portaFrontEnd": this.dado.portaFrontEnd
      }).subscribe(res => {
        this.retornaDados();
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados inserido com sucesso.', life: 3000 });
      });
      this.edit = false;
      this.dadosDialog = false;
    }
  }

  editDados(dado) {
    this.descricaoDialog = "Editar";
    this.edit = true;
    this.dado = { ...dado };
    this.dadosDialog = true;
  }

  inserirDados() {
    if (this.dados.length < 1) {
      this.dado.nome = "";
      this.descricaoDialog = "Inserir";
      this.edit = false;
      this.dadosDialog = true;
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Fábrica já existente! Somente uma fábrica pode ser cadastrada.', life: 3000 });
    }
  }

  hideDialog() {
    this.editCruzamento = false;
    this.dadosDialog = false;
    this.editDialogMarca = false;
    this.edit = false;
  }

  pesquisarMarca(page?: any) {
    this.service.getDados(`/cadastrar_fabrica/listarMarca?size=${this.tamanhoPagina}&page=${page}`).subscribe({
      next: (res) => {
        this.dadosMarca = res
        if (this.dadosMarca.length > 0) {
          this.totalRegistros = res[0].totalRegistro;
        } else {
          this.totalRegistros = 0
        }
      },
      error: (erro) => {
        this.totalRegistros = 0;
      }
    })
  }

  pesquisar() {
    this.first = 0;
    this.paginaAtual = 1;
    this.pesquisarMarca(this.paginaAtual);
  }

  eventoPaginacao(event: any): void {
    this.paginaAtual = event.page + 1;
    this.tamanhoPagina = event.rows;
    this.first = event.first;
    this.pesquisarMarca(this.paginaAtual);
  }

  editMarca(dadoMarca) {
    this.habilitar = true;
    this.descricaoDialog = "Editar";
    this.edit = true;
    this.dadoMarca = { ...dadoMarca };
    this.editDialogMarca = true;
  }

  inserirMarca() {
    this.habilitar = false;
    this.dadoMarca.idMarca = ""
    this.dadoMarca.descricao = ""
    this.descricaoDialog = "Inserir";
    this.edit = false;
    this.editDialogMarca = true;
  }

  salvarMarca() {
    this.submitted = true;

    // Verifica se campo(s) estão preenchidos
    if (typeof this.dadoMarca.idMarca === "undefined") {
      this.messageService.add({ key: 'idMarca', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }
    if (typeof this.dadoMarca.descricao === "undefined") {
      this.messageService.add({ key: 'descricao', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }

    // Verifica se for inserção ou alteracão
    if (this.edit) {
      this.service.putDados(`/cadastrar_fabrica/atualizarMarca?idMarca=${this.dadoMarca.idMarca}&descricao=${this.dadoMarca.descricao}`, {
      }).subscribe(res => {
        this.pesquisar();
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dado Alterado com sucesso.', life: 3000 });
      });
      this.edit = false;
      this.editDialogMarca = false;

    } else {
      this.service.postDados(`/cadastrar_fabrica/cadastrarMarca?idMarca=${this.dadoMarca.idMarca}&descricao=${this.dadoMarca.descricao}`, {
      }).subscribe(res => {
        this.pesquisar();
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados inserido com sucesso.', life: 3000 });
      });

      this.edit = false;
      this.editDialogMarca = false;
    }
  }

  pesquisarCruzamento() {
    this.service.getDados(`/cadastrar_fabrica/listarCruzamento`).subscribe({
      next: (res) => {
        this.dadosCruzamento = res;
      }
    })
  }

  saveCruzamento() {
    if (this.edit) {
      this.service.putDados(`/cadastrar_fabrica/alterarCruzamento?` +
        `idFabrica=${this.Fabrica}&idMarca=${this.Marca}&idMarcaAntigo=${this.ValorAntigo}`, {}).subscribe({
          next: (res) => {
            this.editCruzamento = false;
            this.pesquisarCruzamento();
          }
        })
    } else {
      this.service.postDados(`/cadastrar_fabrica/cruzamento?idFabrica=${this.Fabrica}&idMarca=${this.Marca}`, {}).subscribe({
        next: (res) => {
          this.editCruzamento = false;
          this.pesquisarCruzamento();
        }
      })
    }
  }

  editarCruzamento(dadoCruzamento) {
    this.editCruzamento = true
    this.descricaoDialog = "Editar"
    this.edit = true;
    this.ValorAntigo = dadoCruzamento.idMarca;
    this.Marca = dadoCruzamento.idMarca;
    this.pesquisarDropdown();
  }

  adicionarCruzamento() {
    this.editCruzamento = true
    this.descricaoDialog = "Adicionar Cruzamento"
    this.Marca = ""
    this.pesquisarDropdown();
  }

  excluirCruzamento(dadosCruzamento) {
    this.service.exclusao(`/cadastrar_fabrica/excluirCruzamento?` +
      `idFabrica=${dadosCruzamento.idFabrica}&idMarca=${dadosCruzamento.idMarca}`).subscribe({
        next: res => {
          this.pesquisarCruzamento()
        }
      })
  }

  pesquisarDropdown() {
    this.service.getDados(`/cadastrar_fabrica/listarDropdown`).subscribe({
      next: (res) => this.dadosDropdown = res
    })
  }

  restart(){
    this.service.getDados(`/cadastrar_fabrica/restart`).toPromise();
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("token");
    setInterval(function() { window.location.reload() }, 2000);
  }

  carregarParametros() {
    this.service.getDados('/cadastrar_fabrica/parametros').subscribe({
      next: (res) => {
        this.parametrosFabrica = {
          processarArquivos: !!res.processar_arquivos,
          envioAgregado: !!res.envio_agregado,
          necessitaModelo: !!res.necessita_modelo,
          obrigatoriedadeTipoItem: !!res.obrigatoriedade_tipo_item
        };
        
        localStorage.setItem('parametrosFabrica', JSON.stringify(this.parametrosFabrica));
        
        this.valorOriginalProcessarArquivos = this.parametrosFabrica.processarArquivos;
        this.parametrosOriginais = {
          processarArquivos: this.parametrosFabrica.processarArquivos,
          envioAgregado: this.parametrosFabrica.envioAgregado,
          necessitaModelo: this.parametrosFabrica.necessitaModelo,
          obrigatoriedadeTipoItem: this.parametrosFabrica.obrigatoriedadeTipoItem
        };
        this.mostrarAvisoReinicializacao = false;
        this.mostrarAvisoAlteracoesNaoSalvas = false;
      },
      error: (error) => {
        // Em caso de erro, usar valores padrão
        this.parametrosFabrica = {
          processarArquivos: false,
          envioAgregado: false,
          necessitaModelo: false,
          obrigatoriedadeTipoItem: false
        };
        
        // Tentar carregar do localStorage como fallback
        const parametrosSalvos = localStorage.getItem('parametrosFabrica');
        if (parametrosSalvos) {
          const parsed = JSON.parse(parametrosSalvos);
          this.parametrosFabrica = {
            processarArquivos: !!parsed.processarArquivos,
            envioAgregado: !!parsed.envioAgregado,
            necessitaModelo: !!parsed.necessitaModelo,
            obrigatoriedadeTipoItem: !!parsed.obrigatoriedadeTipoItem
          };
        }
        
        this.valorOriginalProcessarArquivos = this.parametrosFabrica.processarArquivos;
        this.parametrosOriginais = {
          processarArquivos: this.parametrosFabrica.processarArquivos,
          envioAgregado: this.parametrosFabrica.envioAgregado,
          necessitaModelo: this.parametrosFabrica.necessitaModelo,
          obrigatoriedadeTipoItem: this.parametrosFabrica.obrigatoriedadeTipoItem
        };
        this.mostrarAvisoReinicializacao = false;
        this.mostrarAvisoAlteracoesNaoSalvas = false;
        
        this.messageService.add({ 
          severity: 'warn', 
          summary: 'Aviso', 
          detail: 'Não foi possível carregar os parâmetros do servidor. Usando valores padrão.', 
          life: 3000 
        });
      }
    });
  }

  salvarParametros() {
    const payload = {
      "envio_agregado": this.parametrosFabrica.envioAgregado,
      "processar_arquivos": this.parametrosFabrica.processarArquivos,
      "necessita_modelo": this.parametrosFabrica.necessitaModelo,
      "obrigatoriedade_tipo_item": this.parametrosFabrica.obrigatoriedadeTipoItem
    };

    const houveAlteracaoProcessarArquivos = this.parametrosFabrica.processarArquivos !== this.parametrosOriginais.processarArquivos;

    this.service.postDados('/cadastrar_fabrica/parametros', payload).subscribe({
      next: (res) => {
        localStorage.setItem('parametrosFabrica', JSON.stringify(this.parametrosFabrica));
        
        this.valorOriginalProcessarArquivos = this.parametrosFabrica.processarArquivos;
        this.parametrosOriginais = {
          processarArquivos: this.parametrosFabrica.processarArquivos,
          envioAgregado: this.parametrosFabrica.envioAgregado,
          necessitaModelo: this.parametrosFabrica.necessitaModelo,
          obrigatoriedadeTipoItem: this.parametrosFabrica.obrigatoriedadeTipoItem
        };
        this.mostrarAvisoReinicializacao = false;
        this.mostrarAvisoAlteracoesNaoSalvas = false;
        
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Sucesso', 
          detail: 'Parâmetros salvos com sucesso!', 
          life: 3000 
        });

        if (houveAlteracaoProcessarArquivos) {
          this.restart();
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      },
      error: (error) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao salvar parâmetros!', 
          life: 3000 
        });
      }
    });
  }

  cancelarAlteracaoProcessarArquivos() {
    this.parametrosFabrica.processarArquivos = this.valorOriginalProcessarArquivos;
    this.mostrarAvisoReinicializacao = false;
    
    this.valorOriginalProcessarArquivos = this.parametrosFabrica.processarArquivos;
    
    this.messageService.add({ 
      severity: 'info', 
      summary: 'Alteração Cancelada', 
      detail: 'Parâmetro "Processar Arquivos" restaurado ao valor original.', 
      life: 3000 
    });
    this.verificarAlteracoesNaoSalvas(); 
  }

  onProcessarArquivosChange() {
    if (this.parametrosFabrica.processarArquivos !== this.valorOriginalProcessarArquivos) {
      this.mostrarAvisoReinicializacao = true;
    } else {
      this.mostrarAvisoReinicializacao = false;
    }
    this.verificarAlteracoesNaoSalvas();
  }

  onEnvioAgregadoChange() {
    this.verificarAlteracoesNaoSalvas();
  }

  onNecessitaModeloChange() {
    this.verificarAlteracoesNaoSalvas();
  }

  verificarAlteracoesNaoSalvas() {
    setTimeout(() => {
      const processarArquivosAtual = !!this.parametrosFabrica.processarArquivos;
      const envioAgregadoAtual = !!this.parametrosFabrica.envioAgregado;
      const necessitaModeloAtual = !!this.parametrosFabrica.necessitaModelo;
      const obrigatoriedadeTipoItemAtual = !!this.parametrosFabrica.obrigatoriedadeTipoItem;
      
      const processarArquivosOriginal = !!this.parametrosOriginais.processarArquivos;
      const envioAgregadoOriginal = !!this.parametrosOriginais.envioAgregado;
      const necessitaModeloOriginal = !!this.parametrosOriginais.necessitaModelo;
      const obrigatoriedadeTipoItemOriginal = !!this.parametrosOriginais.obrigatoriedadeTipoItem;
      
      const temAlteracoes = 
        processarArquivosAtual !== processarArquivosOriginal ||
        envioAgregadoAtual !== envioAgregadoOriginal ||
        necessitaModeloAtual !== necessitaModeloOriginal;
        obrigatoriedadeTipoItemAtual !== obrigatoriedadeTipoItemOriginal;
        
      this.mostrarAvisoAlteracoesNaoSalvas = temAlteracoes;
    }, 0);
  }
}